/**
 * API Client - Admin API Integration
 *
 * Centralized API client for admin panel.
 * Follows ENV_KEYS system pattern (no fallback values).
 */

const API_ADMIN_BASE_URL = import.meta.env.VITE_API_ADMIN_BASE_URL;
if (!API_ADMIN_BASE_URL) {
  throw new Error('VITE_API_ADMIN_BASE_URL is not configured');
}

export { API_ADMIN_BASE_URL };
